import React, { useState } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import CareersProfileForm, {
	ICareersProfileModalI18n,
} from '../CareersProfileForm';

export interface ICareersProfileProgressCardI18n {
	progressHeading: string;
	progressDescription: string;
	completeProfileLinkLabel: string;
}

export interface ICareersProfileProgressCardProps extends IBaseElementProps {
	/**
	 * Progress Amount
	 */
	progressAmount?: number;
	modalI18n?: ICareersProfileModalI18n;
	i18n?: ICareersProfileProgressCardI18n;
}

const CareersProfileProgressCard: React.FC<ICareersProfileProgressCardProps> =
	({
		id,
		className,
		classNames = [],
		progressAmount,
		modalI18n,
		i18n = {
			progressHeading: '40% there',
			progressDescription:
				'Only a few more minutes to complete your Calian Career Centre profile to apply to careers faster.',
			completeProfileLinkLabel: 'Update your profile',
		},
	}) => {
		const [showModal, setShowModal] = useState<boolean>(false);
		let progressBarWidth = 0;

		if (progressAmount) {
			progressBarWidth = progressAmount;
		}

		let progressBarStyle = {
			width: `${progressBarWidth}%`,
		};

		return (
			<div
				id={id}
				className={
					className ||
					cn(
						'calian-career-profile-progress-card px-3 py-2 p-sm-3 px-lg-5 py-lg-4 card border-dark-border bg-transparent rounded-4 rounded-sm-5',
						...classNames,
					)
				}
			>
				<div className="card-header d-none d-sm-flex flex-row align-items-center mb-1 p-0 border-0 bg-transparent">
					<div className="card-header__progress-heading me-4">
						{i18n.progressHeading && (
							<h4 className="card-header__progress-heading-text h5 mb-0">
								{i18n.progressHeading}
							</h4>
						)}
					</div>
					<div className="card-header__progress-amount flex-grow-1 pe-lg-4">
						{progressAmount && (
							<div
								className="progress rounded-5 bg-white"
								role="progressbar"
								aria-label="Basic example"
								aria-valuenow={progressAmount}
								aria-valuemin={0}
								aria-valuemax={100}
							>
								<div
									className="progress-bar bg-primary"
									style={progressBarStyle}
								></div>
							</div>
						)}
					</div>
				</div>
				<div className="card-body d-none d-sm-flex flex-column mt-1 p-0">
					{i18n.progressDescription && (
						<p className="card-body__progress-description mb-2 fs-7">
							{i18n.progressDescription}
						</p>
					)}
					{i18n.completeProfileLinkLabel && (
						<Button
							label={i18n.completeProfileLinkLabel}
							onClick={() => setShowModal(true)}
							className="card-body__complete-profile-link btn btn-sm btn-primary mt-1 me-auto"
						/>
					)}
				</div>
				<div
					className="calian-career-profile-progress-card__mobile-accordion accordion d-sm-none"
					id="progress-card-accordion"
				>
					<div className="accordion-item bg-transparent border-0">
						<h2
							className="accordion-header border-0"
							id="progress-card-accordion__heading"
						>
							<button
								className="accordion-button bg-transparent shadow-none p-0"
								type="button"
								data-bs-toggle="collapse"
								data-bs-target="#progress-card-accordion__collapse"
								aria-expanded="true"
								aria-controls="collapseOne"
							>
								<div className="d-flex w-100 align-items-center me-3">
									{i18n.progressHeading && (
										<h4 className="mb-0 fs-6">
											{i18n.progressHeading}
										</h4>
									)}
									<div className="flex-grow-1 ms-3">
										{progressAmount && (
											<div
												className="progress-card-accordion__progress-bar progress rounded-5"
												role="progressbar"
												aria-label="Basic example"
												aria-valuenow={progressAmount}
												aria-valuemin={0}
												aria-valuemax={100}
											>
												<div
													className="progress-bar bg-primary"
													style={progressBarStyle}
												></div>
											</div>
										)}
									</div>
								</div>
							</button>
						</h2>
						<div
							id="progress-card-accordion__collapse"
							className="accordion-collapse collapse show"
							aria-labelledby="progress-card-accordion__heading"
							data-bs-parent="#progress-card-accordion"
						>
							<div className="accordion-body p-0">
								<div className="d-flex flex-column mt-1 p-0">
									{i18n.progressDescription && (
										<p className="mt-2 mb-2 fs-8">
											{i18n.progressDescription}
										</p>
									)}
									{i18n.completeProfileLinkLabel && (
										<Button
											label={
												i18n.completeProfileLinkLabel
											}
											onClick={() => setShowModal(true)}
											className="btn btn-sm btn-primary mt-1 mb-1 px-3 me-auto fs-8"
										/>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				{showModal && (
					<CareersProfileForm
						onCancel={() => setShowModal(false)}
						modalI18n={modalI18n}
					/>
				)}
			</div>
		);
	};

export default CareersProfileProgressCard;
